import React from 'react';
import placeholder from "@assets/img/default.png";
import cargo from "@assets/img/cargo.png";
import infra from "@assets/img/infra.png";
import gtc from "@assets/img/gtc.png";
import { Link } from '@ambiguous/link';
import Image from '@assets/tsx/image';
export function CardSimple({ mediaItemUrl, altText, date, categoryName, uri, title, hasFeaturedGallery, hasFeaturedVideo, mediaItemSrcSet }) {
    let placeholderImg;
    switch (THEME) {
        case ('cargo'):
            placeholderImg = cargo;
            break;
        case ('infra'):
            placeholderImg = infra;
            break;
        case ('gtc'):
            placeholderImg = gtc;
            break;
        default:
            placeholderImg = placeholder;
            break;
    }
    return (React.createElement("div", { className: "ltg-card ltg-card-simple" },
        React.createElement(Link, { href: uri, className: "ltg-card-img-wrap" },
            !!mediaItemUrl ?
                React.createElement(Image, { src: mediaItemUrl, className: "ltg-card-img", alt: altText || title, srcSet: mediaItemSrcSet })
                :
                    React.createElement("img", { src: placeholderImg, className: "ltg-card-img", alt: altText || title, srcSet: mediaItemSrcSet }),
            (hasFeaturedGallery || hasFeaturedVideo) && (React.createElement("div", { className: "ltg-card-icon-wrap" },
                hasFeaturedVideo && React.createElement(CardSimpleIcon, { icon: "fas fa-play", color: "primary" }),
                hasFeaturedGallery && React.createElement(CardSimpleIcon, { icon: "fas fa-camera", color: "white" })))),
        React.createElement("div", { className: "ltg-card-meta" },
            categoryName && React.createElement("span", { className: "ltg-card-category" },
                categoryName,
                date && ', '),
            date && React.createElement("span", { className: "ltg-card-date" }, date.substring(0, 10))),
        React.createElement("h3", { className: 'ltg-card-title', role: "presentation" },
            React.createElement(Link, { href: uri, className: "ltg-card-title" }, title))));
}
export function CardSimpleIcon({ icon, color }) {
    return (React.createElement("span", { className: `ltg-card-icon type-${color}` },
        React.createElement("i", { className: icon })));
}
